import axios from 'axios';

// Sử dụng URL trực tiếp của Google Apps Script
const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxozvcbb6t20mES4EDGdinVw0Uq8w4BCTG4GyGc7eWg6meloBkFaIeu4fTubuaYPoQqRQ/exec';

let cachedData = null;
let cachedTranscripts = null;
let cachedCatechismData = null;
let cachedCatechists = null;

const classMap = {
  'to-mau': 'Tô Màu',
  'khai-tam-1a-nu': 'Khai Tâm 1A Nữ',
  'khai-tam-1b-nam': 'Khai Tâm 1B Nam',
  'khai-tam-2a-nu': 'Khai Tâm 2A Nữ',
  'khai-tam-2b-nu': 'Khai Tâm 2B Nữ',
  'khai-tam-2c-nam': 'Khai Tâm 2C Nam',
  'khai-tam-2d-nam': 'Khai Tâm 2D Nam',
  'ruoc-le-1a-nu': 'Rước Lễ 1A Nữ',
  'ruoc-le-1b-nu': 'Rước Lễ 1B Nữ',
  'ruoc-le-1c-nam': 'Rước Lễ 1C Nam',
  'ruoc-le-1d-nam': 'Rước Lễ 1D Nam',
  'ruoc-le-2a-nu': 'Rước Lễ 2A Nữ',
  'ruoc-le-2b-nu': 'Rước Lễ 2B Nữ',
  'ruoc-le-2c-nam': 'Rước Lễ 2C Nam',
  'ruoc-le-2d-nam': 'Rước Lễ 2D Nam',
  'them-suc-1a-nu': 'Thêm Sức 1A Nữ',
  'them-suc-1b-nu': 'Thêm Sức 1B Nữ',
  'them-suc-1c-nam': 'Thêm Sức 1C Nam',
  'them-suc-1d-nam': 'Thêm Sức 1D Nam',
  'them-suc-2a-nu': 'Thêm Sức 2A Nữ',
  'them-suc-2b-nu': 'Thêm Sức 2B Nữ',
  'them-suc-2c-nam': 'Thêm Sức 2C Nam',
  'them-suc-2d-nam': 'Thêm Sức 2D Nam',
  'bao-dong-1a-nu': 'Bao Đồng 1A Nữ',
  'bao-dong-1b-nam': 'Bao Đồng 1B Nam',
  'bao-dong-2a-nu': 'Bao Đồng 2A Nữ',
  'bao-dong-2b-nam': 'Bao Đồng 2B Nam',
  'bao-dong-3': 'Bao Đồng 3',
  'bao-dong-4': 'Bao Đồng 4',
  'du-bi-giao-ly-vien': 'Dự Bị Giáo Lý Viên',
};

export const login = async (username, password, retries = 3) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      console.log(`GoogleSheetsService.login - Attempt ${attempt} - Sending login request to server`);
      const response = await axios.get(SCRIPT_URL, {
        params: { action: 'login', username, password },
        timeout: 10000,
      });
      if (response.data.success) {
        console.log('GoogleSheetsService.login - Login successful, storing user data');
        localStorage.setItem('catechistFullName', response.data.fullName);
        localStorage.setItem('username', username);
        localStorage.setItem('catechistHolyName', response.data.holyName || '');
        localStorage.setItem('catechistClassName', response.data.className || '');
        localStorage.setItem('userRole', response.data.role || 'catechist');
        localStorage.setItem('blockLeader', response.data.blockLeader || '');
        localStorage.setItem('boardLeader', response.data.boardLeader || '');
      }
      return response.data;
    } catch (error) {
      console.error(`Attempt ${attempt} failed:`, error);
      if (attempt === retries) {
        console.error('All retry attempts failed');
        return { success: false, message: 'Lỗi kết nối server sau nhiều lần thử' };
      }
      await new Promise(resolve => setTimeout(resolve, 2000 * attempt));
    }
  }
};

export const updateAttendance = async (studentId, catechistFullName) => {
  try {
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'updateAttendance', studentId, catechistFullName },
      timeout: 10000,
    });
    cachedData = null;
    return response.data.success;
  } catch (error) {
    console.error('Error updating attendance:', error);
    return false;
  }
};

export const updateChurchAttendance = async (studentId, date, status) => {
  try {
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'updateChurchAttendance', studentId, date, status },
      timeout: 10000,
    });
    if (!response.data.success) {
      throw new Error(response.data.message || 'Lỗi khi cập nhật điểm danh đi lễ');
    }
    cachedData = null;
    return response.data.success;
  } catch (error) {
    console.error('Error updating church attendance:', error);
    throw error;
  }
};

export const updateCatechismAttendance = async (studentId, date, status) => {
  try {
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'updateCatechismAttendance', studentId, date, status },
      timeout: 10000,
    });
    if (!response.data.success) {
      throw new Error(response.data.message || 'Lỗi khi cập nhật điểm danh học giáo lý');
    }
    cachedCatechismData = null;
    return response.data.success;
  } catch (error) {
    console.error('Error updating catechism attendance:', error);
    throw error;
  }
};

export const fetchStudentName = async (studentId) => {
  try {
    console.log('Fetching student name for studentId:', studentId);
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'fetchStudentName', studentId },
      timeout: 10000,
    });
    return response.data.name;
  } catch (error) {
    console.error('Error fetching student name:', error);
    return 'Lỗi';
  }
};

export const fetchAllDataFromSheets = async () => {
  if (cachedData) {
    console.log('Returning cached data');
    return cachedData;
  }

  try {
    console.log('Fetching all data from Google Sheets');
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'fetchAllData' },
      timeout: 50000,
    });

    const data = {
      students: response.data.students || [],
      attendance: response.data.attendance || [],
      dates: response.data.dates || [],
    };
    cachedData = data;
    return data;
  } catch (error) {
    console.error('Error fetching all data from sheets:', error);
    return { students: [], attendance: [], dates: [] };
  }
};

export const fetchAllTranscripts = async () => {
  if (cachedTranscripts) {
    console.log('Returning cached transcripts');
    return cachedTranscripts;
  }

  try {
    console.log('Fetching all transcripts from Google Sheets');
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'fetchAllTranscripts' },
      timeout: 10000,
    });

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    const transcripts = response.data.transcripts || [];
    cachedTranscripts = transcripts;
    return transcripts;
  } catch (error) {
    console.error('Error fetching all transcripts from sheets:', error);
    return [];
  }
};

export const fetchTranscript = async (classId) => {
  try {
    console.log('GoogleSheetsService.fetchTranscript - Fetching transcript for classId:', classId);
    const normalizedClassId = classMap[classId] || classId;
    console.log('Normalized classId:', normalizedClassId);

    const allTranscripts = await fetchAllTranscripts();

    const transcript = {};
    allTranscripts.forEach((item) => {
      if (item.className === normalizedClassId) {
        transcript[item.id] = {
          semester1: item.semester1,
          semester2: item.semester2,
          yearly: item.yearly,
        };
      }
    });

    return transcript;
  } catch (error) {
    console.error('Error fetching transcript:', error);
    return {};
  }
};

export const fetchStudentListByClass = async (className) => {
  const data = await fetchAllDataFromSheets();
  const students = data.students
    .filter((student) => student.className === className)
    .map((student) => ({
      id: student.id || '',
      holyName: student.holyName || '',
      fullName: student.fullName || '',
    }));
  return students;
};

export const fetchAttendanceByClass = async (className) => {
  const data = await fetchAllDataFromSheets();
  const attendance = data.attendance
    .filter((att) => {
      const student = data.students.find((s) => s.id === att.id);
      return student && student.className === className;
    })
    .map((att) => ({
      id: att.id,
      attendance: att.attendance,
    }));
  return {
    dates: data.dates,
    attendance,
  };
};

export const fetchAllCatechismAttendance = async () => {
  try {
    console.log('Fetching all catechism attendance');
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'fetchAllCatechismAttendance' },
      timeout: 10000,
    });
    cachedCatechismData = response.data;
    return response.data;
  } catch (error) {
    console.error('Error fetching all catechism attendance:', error);
    return { dates: [], attendance: [] };
  }
};

export const fetchCatechismAttendanceByClass = async (className) => {
  try {
    if (!cachedCatechismData) {
      console.log('No cached catechism data, fetching all catechism attendance');
      cachedCatechismData = await fetchAllCatechismAttendance();
    }

    console.log('Filtering catechism attendance for class:', className);
    const allAttendance = cachedCatechismData.attendance || [];
    const allDates = cachedCatechismData.dates || [];

    const filteredAttendance = allAttendance.filter((att) => att.className === className).map((att) => ({
      id: att.id,
      attendance: att.attendance,
    }));

    return {
      dates: allDates,
      attendance: filteredAttendance,
    };
  } catch (error) {
    console.error('Error fetching catechism attendance:', error);
    return { dates: [], attendance: [] };
  }
};

export const fetchStudentQRCode = async (studentId) => {
  try {
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'fetchStudentQRCode', studentId },
      timeout: 10000,
    });
    return response.data.qrCode || null;
  } catch (error) {
    console.error('Error fetching student QR code:', error);
    return null;
  }
};

export const updateStudentStatus = async (studentId, status) => {
  try {
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'updateStudentStatus', studentId, status },
      timeout: 10000,
    });
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    cachedData = null;
    return response.data;
  } catch (error) {
    console.error('Error updating student status:', error);
    throw error;
  }
};

export const updateStudentDateOfBirth = async (studentId, dateOfBirth) => {
  try {
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'updateStudentDateOfBirth', studentId, dateOfBirth },
      timeout: 10000,
    });
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    cachedData = null;
    return response.data;
  } catch (error) {
    console.error('Error updating student date of birth:', error);
    throw error;
  }
};

export const changePassword = async (username, currentPassword, newPassword) => {
  try {
    console.log('Changing password for username:', username);
    const response = await axios.get(SCRIPT_URL, {
      params: {
        action: 'changePassword',
        username,
        currentPassword,
        newPassword,
      },
      timeout: 10000,
    });
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};

export const updateTranscript = async (classId, transcriptData) => {
  try {
    console.log('GoogleSheetsService.updateTranscript - Class ID:', classId);
    const payload = {
      action: 'updateTranscript',
      classId: classId,
      transcriptData: transcriptData,
    };
    console.log('GoogleSheetsService.updateTranscript - Sending payload:', JSON.stringify(payload));

    const response = await axios.post(SCRIPT_URL, payload, {
      headers: {
        'Content-Type': 'text/plain;charset=utf-8',
      },
      timeout: 20000,
    });

    console.log('GoogleSheetsService.updateTranscript - Response from server:', response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || response.data.error || 'Lỗi không xác định từ server');
    }

    cachedTranscripts = null;
    return response.data;
  } catch (error) {
    console.error('Error updating transcript:', error);
    if (error.response) {
      console.error('Error response data:', error.response.data);
      console.error('Error response status:', error.response.status);
      console.error('Error response headers:', error.response.headers);
      throw new Error(`Server Error ${error.response.status}: ${JSON.stringify(error.response.data)}`);
    } else if (error.request) {
      console.error('Error request:', error.request);
      throw new Error('Không nhận được phản hồi từ server. Vui lòng kiểm tra kết nối mạng.');
    } else {
      console.error('Error message:', error.message);
      throw new Error(`Lỗi thiết lập request: ${error.message}`);
    }
  }
};

export const fetchTranscriptLockStatus = async (classId) => {
  try {
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'fetchTranscriptLockStatus', classId },
      timeout: 10000,
    });
    console.log(response.data);
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.isLocked;
  } catch (error) {
    console.error('Error fetching transcript lock status:', error);
    throw error;
  }
};

export const updateTranscriptLockStatus = async (classId, isLocked) => {
  try {
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'updateTranscriptLockStatus', classId, isLocked },
      timeout: 10000,
    });
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error) {
    console.error('Error updating transcript lock status:', error);
    throw error;
  }
};

export const fetchAllCatechists = async () => {
  if (cachedCatechists) {
    console.log('Returning cached catechists');
    return cachedCatechists;
  }

  try {
    console.log('Fetching all catechists from Google Sheets');
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'fetchAllCatechists' },
      timeout: 10000,
    });

    if (!response.data.success) {
      if (response.data.catechists && Array.isArray(response.data.catechists)) {
         cachedCatechists = response.data.catechists;
         return cachedCatechists;
      }
      throw new Error(response.data.message || 'Unknown error fetching catechists');
    }

    const catechists = response.data.catechists || [];
    cachedCatechists = catechists;
    return catechists;
  } catch (error) {
    console.error('Error fetching all catechists from sheets:', error);
    return [];
  }
};

export const addCatechist = async (catechistData) => {
  try {
    console.log('GoogleSheetsService.addCatechist - Sending request to add catechist:', catechistData);
    const response = await axios.get(SCRIPT_URL, {
      params: {
        action: 'addCatechist',
        idCode: catechistData.idCode,
        holyName: catechistData.holyName,
        fullName: catechistData.fullName,
        username: catechistData.username,
      },
      timeout: 15000,
    });

    if (!response.data.success) {
      throw new Error(response.data.message || 'Lỗi khi thêm giáo lý viên.');
    }
    cachedCatechists = null;
    return response.data;
  } catch (error) {
    console.error('Error adding catechist:', error);
    throw error.response ? new Error(error.response.data.message || `Server Error ${error.response.status}`) : error;
  }
};

export const updateCatechist = async (idCode, updates) => {
  try {
    console.log('GoogleSheetsService.updateCatechist - Sending request to update catechist:', { idCode, updates });
    const response = await axios.get(SCRIPT_URL, {
      params: {
        action: 'updateCatechist',
        idCode,
        className: updates.className || '',
        blockLeader: updates.blockLeader || '',
      },
      timeout: 15000,
    });

    if (!response.data.success) {
      throw new Error(response.data.message || 'Lỗi khi cập nhật giáo lý viên.');
    }
    cachedCatechists = null;
    return response.data;
  } catch (error) {
    console.error('Error updating catechist:', error);
    throw error.response ? new Error(error.response.data.message || `Server Error ${error.response.status}`) : error;
  }
};

export const fetchStudentCount = async () => {
  try {
    console.log('Fetching student count from Google Sheets');
    const response = await axios.get(SCRIPT_URL, {
      params: { action: 'fetchStudentCount' },
      timeout: 10000,
    });
    if (!response.data.success) {
      throw new Error(response.data.message || 'Lỗi khi lấy số lượng thiếu nhi');
    }
    return response.data.count || 0;
  } catch (error) {
    console.error('Error fetching student count:', error);
    throw error;
  }
};

export const addNewStudent = async (studentData) => {
  try {
    console.log('Adding new student:', studentData);
    const response = await axios.get(SCRIPT_URL, {
      params: {
        action: 'addNewStudent',
        id: studentData.id,
        holyName: studentData.holyName,
        fullName: studentData.fullName,
        className: studentData.className,
        dateOfBirth: studentData.dateOfBirth,
      },
      timeout: 15000,
    });
    if (!response.data.success) {
      throw new Error(response.data.message || 'Lỗi khi thêm thiếu nhi');
    }
    cachedData = null; // Clear cache to ensure fresh data
    return response.data;
  } catch (error) {
    console.error('Error adding new student:', error);
    throw error;
  }
};